class MainNav {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
		self.active = false;
	}

	init() {
		let self = this;

		const hamburger = self.elem.querySelector('.js-main-nav-toggle');
		const body = document.querySelector('body');

		hamburger.addEventListener('click', evt => {
			evt.preventDefault();

			self.active = !self.active;
			hamburger.setAttribute("aria-expanded", self.active);

			if(self.active) {
				self.elem.classList.add('menu-active');
				body.classList.add('is-no-scroll');
			} else {
				self.elem.classList.remove('menu-active');
				body.classList.remove('is-no-scroll');
			}
		})
	}
}

export default MainNav;